import { ga4Container, ga4Domains, ga4HasCrossDomains } from "Constants/GA4";

export const initializeGa4 = ({ userId = null, clientId = null, sessionId = null }) => {
  if (ga4HasCrossDomains && (!clientId || !sessionId)) return;

  const additionalConfig = {
    ...(userId && { user_id: userId }),
    ...(clientId && { client_id: clientId }),
    ...(sessionId && { session_id: sessionId }),
  };

  gtag('config', ga4Container, {
    send_page_view: true,
    cookie_flags: 'SameSite=None;Secure',
    linker: { domains: ga4Domains.split(',').map(domain => domain.trim()) },
    ...additionalConfig,
  });
}
